import { render } from "./OutdatedMachines.vue?vue&type=template&id=47af2d94&bindings={\"group\":\"props\",\"hasFilters\":\"options\",\"allFilters\":\"options\",\"searchPlaceholder\":\"options\",\"getIssueHelp\":\"options\",\"fetchData\":\"options\",\"refresh\":\"options\"}"
import script from "./OutdatedMachines.vue?vue&type=script&lang=js"
export * from "./OutdatedMachines.vue?vue&type=script&lang=js"
script.render = render

export default script